//Same has Delphi.LicenseRenewal.Data.Store
var EquipmentType;
(function (EquipmentType) {
    EquipmentType[EquipmentType["None"] = 0] = "None";
    EquipmentType[EquipmentType["Dongle"] = 1] = "Dongle";
    EquipmentType[EquipmentType["Vci"] = 2] = "Vci";
    EquipmentType[EquipmentType["DsFlash"] = 3] = "DsFlash";
})(EquipmentType || (EquipmentType = {}));
class SiretAndDunsDisplayManager {
    constructor(containerSelector) {
        if (containerSelector)
            this.container = $(containerSelector);
        else
            this.container = $('body');
        $(document).on('change', containerSelector + ' #country_field', () => {
            this.UpdateSiretNumberFieldDisplay();
        });
        this.UpdateSiretNumberFieldDisplay();
    }
    UpdateSiretNumberFieldDisplay() {
        const equipmentType = this.container.find('#equipmentType').val();
        const selectedCountryId = this.container.find("#country_field").val();
        if (selectedCountryId === $('#hidden_france_country_id').val() && equipmentType !== EquipmentType.DsFlash) {
            this.container.find('#siret_number_field').removeClass('hidden');
            this.container.find('#siret_number_field').parents("#siret_field_container").removeClass('hidden');
            this.container.find('#duns_number_field').removeClass('input-validation-error');
        }
        else {
            this.container.find('#siret_number_field').addClass('hidden');
            this.container.find('#siret_number_field').parents("#siret_field_container").addClass('hidden');
            this.container.find('#siret_number_field').removeClass('input-validation-error');
        }
    }
}
class DelphiCustomValidation {
    constructor() { }
    init() {
        const $jQval = $.validator;
        const adapters = $jQval.unobtrusive.adapters;
        // DUN'S NUMBER VALIDATION
        $jQval.addMethod("dunsvalidation", function (value, element, params) {
            const selectedCountryId = $(params[0]).val();
            const franceId = parseInt(params[1]);
            if (!value)
                return selectedCountryId === franceId;
            value = $.trim(value);
            if (!value)
                return selectedCountryId === franceId;
            return true;
        });
        adapters.add("dunsvalidation", ["franceid"], function (options) {
            const element = $(options.form).find('select#country_field')[0];
            const franceCountryId = parseInt($(options.form).find('input#hidden_france_country_id').val());
            options.rules['dunsvalidation'] = [element, franceCountryId];
            options.messages['dunsvalidation'] = options.message;
        });
        // SIRET NUMBER VALIDATION
        $jQval.addMethod("siretvalidation", function (value, element, params) {
            const selectedCountryId = $(params[0]).val();
            const franceId = parseInt(params[1]);
            if (!value)
                return selectedCountryId !== franceId;
            value = $.trim(value);
            if (!value)
                return selectedCountryId !== franceId;
            return true;
        });
        adapters.add("siretvalidation", ["franceid"], function (options) {
            const element = $(options.form).find('select#country_field')[0];
            const franceCountryId = parseInt($(options.form).find('input#hidden_france_country_id').val());
            options.rules['siretvalidation'] = [element, franceCountryId];
            options.messages['siretvalidation'] = options.message;
        });
        // VCI NUMBER VALIDATION
        $jQval.addMethod("vcivalidation", (value, element, params) => {
            const type = this.getEquipmentTypeValue(params[0]);
            if (type !== EquipmentType.Vci) {
                return true;
            }
            return /^3[0-9]{5}$/.test(value);
        });
        adapters.add('vcivalidation', [], (options) => {
            const element = this.getEquipementTypeInput(options);
            options.rules['vcivalidation'] = [element];
            options.messages['vcivalidation'] = options.message;
        });
        // DS FLASH SECURITY CODE VALIDATION
        $jQval.addMethod("dsflashvalidation", (value, element, params) => {
            const type = this.getEquipmentTypeValue(params[0]);
            if (type !== EquipmentType.DsFlash) {
                return true;
            }
            return /^[a-fA-FIlO0-9/]{2}(-[a-fA-FIlO0-9/]{2}){7}$/.test(value);
        });
        adapters.add('dsflashvalidation', [], (options) => {
            const element = this.getEquipementTypeInput(options);
            options.rules['dsflashvalidation'] = [element];
            options.messages['dsflashvalidation'] = options.message;
        });
        // DS FLASH SECURITY CODE UNICITY
        $jQval.addMethod("dsflashunicity", (value, element, params) => {
            var type = this.getEquipmentTypeValue(params[0]);
            if (type != EquipmentType.DsFlash) {
                return true;
            }
            return /^[a-fA-FIlO0-9/]{2}(-[a-fA-FIlO0-9/]{2}){7}$/.test(value);
        });
        adapters.add('dsflashunicity', [], (options) => {
            var element = this.getEquipementTypeInput(options);
            options.rules['dsflashunicity'] = [element];
            options.messages['dsflashunicity'] = options.message;
        });
        // DISTRIBUTION INFORMATION REQUIRED VALIDATION
        $jQval.addMethod("distributioninfo", (value, element, params) => {
            const type = this.getEquipmentTypeValue(params[0]);
            const requiresDistributionInfo = type === EquipmentType.Vci || type === EquipmentType.DsFlash;
            return !requiresDistributionInfo || !!$.trim(value);
        });
        adapters.add('distributioninfo', [], (options) => {
            const element = this.getEquipementTypeInput(options);
            options.rules['distributioninfo'] = [element];
            options.messages['distributioninfo'] = options.message;
        });
        // MUST BE TRUE VALIDATION
        $jQval.addMethod("mustbetrue", (value, element) => {
            return $(element).is(':checked');
        });
        adapters.add("mustbetrue", [], function (options) {
            options.rules["mustbetrue"] = options.params;
            options.messages["mustbetrue"] = options.message;
        });
        // DISTRIBUTOR CUSTOMER PARAMETER REQUIRED VALIDATION
        $jQval.addMethod("distributorcustomerparameterrequired", (value, element) => {
            const $e = $(element);
            const status = $e.closest('form').find('[name=Status]').val();
            if (status === 'Activated' || status === 1) {
                return !!$e.val();
            }
            return true;
        });
        adapters.add("distributorcustomerparameterrequired", [], function (options) {
            options.rules["distributorcustomerparameterrequired"] = options.params;
            options.messages["distributorcustomerparameterrequired"] = options.message;
        });
    }
    getEquipementTypeInput(options) {
        const url = window.location.href.toLowerCase();
        if (url.indexOf('store') !== -1 || url.indexOf('product') !== -1)
            return $('#createOrderModal input[name=EquipmentType]')[0];
        return $(options.form).find('select#ProductId')[0];
    }
    getEquipmentTypeValue(element) {
        const url = window.location.href.toLowerCase();
        if (url.indexOf('store') !== -1 || url.indexOf('product') !== -1)
            return $(element).val();
        return EquipmentType[$(element).find(":selected").data("type")];
    }
    static clearValidationErrors(form) {
        const validationSummary = form.find('.validation-summary');
        validationSummary.removeClass('validation-summary-errors');
        validationSummary.addClass('validation-summary-valid');
    }
    static addValidationErrors(form, validationErrors) {
        const validationSummary = form.find('.validation-summary');
        if (validationErrors.length > 0) {
            validationSummary.removeClass('validation-summary-valid');
            validationSummary.addClass('validation-summary-errors');
        }
        const errors = validationSummary.find('ul');
        errors.html(validationErrors.map(e => `<li>${e}</li>`).join("\n"));
    }
    static addModelStateErrors(form, modelState) {
        const validationErrors = [];
        for (const invalid in modelState) {
            form.find(':input[name="' + invalid + '"]').addClass('input-validation-error');
            validationErrors.push(modelState[invalid]);
        }
        DelphiCustomValidation.addValidationErrors(form, validationErrors);
    }
    static showRuntimeErrorModal() {
        $('body .body-content > #delphiRuntimeErrorModal').modal('show');
    }
}
const me = new DelphiCustomValidation();
me.init();

//# sourceMappingURL=DelphiCustomValidation.js.map
